import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import "./index.css";

const TemplateWrapper = ({ children }) => (

  <div className="flex flex-col min-h-screen font-sans mt-6 mx-6 text-black cursor-default
  md:flex-row">
    <Helmet
      title="id Project Office"
      meta={[
        { name: "description", content: "id is an an engineering and design studio. We translate emergent technologies into next generation products and services for humans through research, strategy and design." },
        { name: "keywords", content: "design, technology, engineering, studio, blockchain, digital ledger, machine learning, ai, social, digital, IoT, strategy, interaction, data, startup, consultancy, agency, lab, prototype, research, advanced technology, human, user, full stack, developer" }
      ]}
    />
    {children()}
  </div>
  
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js